import { createFileRoute } from "@tanstack/react-router";

import DirectorPage from "@/components/providers/director-page";
import { apiClient } from "@/lib/api";
import type { ApiEnvelope } from "@/lib/page-data";
import type { Director } from "@/lib/types";

const getDirectors = async (): Promise<Director[]> => {
  const req = await apiClient.get<ApiEnvelope<Director[]>>("/api/directors");
  return req.data.details ?? [];
};

const Directors = () => <DirectorPage getData={getDirectors} />;

export const Route = createFileRoute("/admin/directors")({
  component: Directors,
  head: () => ({
    meta: [
      { title: "Directors" },
      { content: "Edit and view directors.", name: "description" },
    ],
  }),
});
